var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5328 0H2.6782C1.63517 0 0.78894 0.815116 0.78894 1.81979V15.1649C0.78894 16.1696 1.63517 16.9847 2.6782 16.9847H16.5328C17.5758 16.9847 18.422 16.1696 18.422 15.1649V1.81979C18.422 0.815116 17.5758 0 16.5328 0ZM8.12951 3.99596C11.0028 3.99596 14.0138 4.57223 16.214 5.80818C16.521 5.97878 16.7217 6.21384 16.7217 6.665C16.7217 7.1806 16.2888 7.54835 15.8086 7.54835C15.6039 7.54835 15.4779 7.49907 15.3008 7.4005C12.4984 5.78922 7.48795 5.40251 4.24471 6.2745C4.10302 6.31241 3.9259 6.37307 3.73697 6.37307C3.21743 6.37307 2.8199 5.98257 2.8199 5.47834C2.8199 4.96273 3.15052 4.6708 3.50475 4.57223C4.89021 4.18173 6.44098 3.99596 8.12951 3.99596ZM15.352 9.69798C15.3481 10.1074 15.0174 10.4373 14.5884 10.4373C14.3837 10.4373 14.246 10.3501 14.1043 10.278C11.6443 8.87529 7.976 8.31039 4.71309 9.16342C4.52417 9.21271 4.42183 9.26199 4.24471 9.26199C3.82357 9.26199 3.48114 8.93215 3.48114 8.52649C3.48114 8.12083 3.68581 7.85165 4.09121 7.74171C5.18541 7.44599 6.30322 7.2261 7.94058 7.2261C10.495 7.2261 12.9629 7.83649 14.9072 8.95111C15.226 9.13309 15.352 9.36815 15.352 9.69798ZM13.5296 12.9243C13.3643 12.9243 13.262 12.875 13.1085 12.7878C10.6525 11.3623 7.79495 11.3017 4.97287 11.859C4.81936 11.8969 4.61863 11.9576 4.50449 11.9576C4.1227 11.9576 3.88261 11.6656 3.88261 11.3585C3.88261 10.9681 4.1227 10.7823 4.4179 10.7216C7.64145 10.0354 10.9358 10.0961 13.7461 11.7149C13.9862 11.8628 14.1279 11.9955 14.1279 12.3405C14.1279 12.6855 13.8485 12.9243 13.5296 12.9243Z",
    fill: "#6A3926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_57"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.78894,
    width: 17.6331,
    height: 16.9847,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.29c5c72df3aab3d16a2c74372969e117.svg";
export { ForwardRef as ReactComponent };